module.exports = __webpack_public_path__ + "img/user.bcc89c6c.png";